
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.557","height":"12.699"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_25750","data-name":"Group 25750","transform":"translate(362.058 -662.666)","fill":"none","stroke":"#5b6474","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_20326","data-name":"Path 20326","d":"M-346 669.291a3.635 3.635 0 00-3.635-3.635 3.522 3.522 0 00-.4.023 4.876 4.876 0 00-4.266-2.512 4.879 4.879 0 00-4.874 4.638 2.565 2.565 0 00-2.381 2.558h0a2.564 2.564 0 002.564 2.564h9.369c.057 0 .112 0 .169-.005a3.634 3.634 0 003.454-3.631z","stroke-miterlimit":"10"}}),_c('g',{attrs:{"id":"Group_25747","data-name":"Group 25747","transform":"translate(-356.09 668.458)","stroke-linecap":"round"}},[_c('line',{attrs:{"id":"Line_684","data-name":"Line 684","y1":"5.714","transform":"translate(1.874 .693)","stroke-miterlimit":"10"}}),_c('path',{attrs:{"id":"Path_20327","data-name":"Path 20327","d":"M-353.471 669.578l-1.874-2.212-1.874 2.212","transform":"translate(357.218 -667.366)","stroke-linejoin":"round"}})])])])
          )
        }
      }
    